module.exports = __webpack_public_path__ + "product/design-template-download-fd50f4807b0fb0d746835d1a60ebbf61.png";